import { Injectable } from '@angular/core';
import { APIUrls } from '../api/apiUrls';
import { ConnectionService } from '../api/connection.service';
import { LibraryService } from '../library/library.service';
import { JSONConverters } from '../models/JSONConverters';
import { Servicio } from '../models/servicio';

@Injectable()
export class ServiciosService { 
    apiUrls: APIUrls = new  APIUrls();
    jsonConverters: JSONConverters = new JSONConverters();
    constructor(
        private connection: ConnectionService,
        private libraryService: LibraryService,
    ) { }

    // * * * Servicios * * * 
    async obtenerServicioPorId(id: number) {
        try {
            var url = this.apiUrls.baseURL + this.apiUrls.serviciosURL + '/id/' + id;
            var json = await this.connection.getRequest(url);
            var registro = this.jsonConverters.servicioDeJSON(json);
            return { error: null, data: { registro: registro } };
        } catch (error) {
            return this.connection.obtenerMensajeError(error.status, null);
        }
    }

    // Crear
    public async crearServicio(registro: Servicio) {
        try {
            var url = this.apiUrls.baseURL + this.apiUrls.serviciosURL;
            const res = await this.connection.postRequest(url, registro);
            return { error: null, data: { mensaje: 'Registro creado con éxito', result: res } };
        } catch (error) {
            return this.connection.obtenerMensajeError(error.status, error.error.message);
        }
    }
    
    // Actualizar
    public async actualizarServicio(registro: Servicio) {
        try {
            var url = this.apiUrls.baseURL + this.apiUrls.serviciosURL;
            const res = await this.connection.putRequest(url, registro);
            return { error: null, data: { mensaje: 'Registro actualizado con éxito', result: res } };
        } catch (error) {
            return this.connection.obtenerMensajeError(error.status, error.error.message);
        }
    }

    // Eliminar
    public async eliminarServicio(ServicioId: number) {
        try {
            var url = this.apiUrls.baseURL + this.apiUrls.serviciosURL + '/id/' + ServicioId;
            const res = await this.connection.deleteRequest(url);
            return { error: null, data: { mensaje: 'Servicio eliminada con éxito', result: res } };
        } catch (error) {
            return this.connection.obtenerMensajeError(error.status, null);
        }
    }

    // Todas
    async obtenerTodas() {
        try {
            var url = this.apiUrls.baseURL + this.apiUrls.serviciosURL;
            var json = await this.connection.getRequest(url);

            var registros = [];
            for (let i = 0; i < json.length; i++) {
                const element = json[i];
                registros.push(this.jsonConverters.servicioDeJSON(element));
            }
            return { error: null, data: { registros: registros } };
        } catch (error) {
            return this.connection.obtenerMensajeError(error.status, 'Ha ocurrido un error al obtener las servicios.');
        }
    }

    // * * * * * * Archivos * * * * * *
    async guardarArchivoEnServidorServicios(archivo: File){
        try {//
            var url = this.apiUrls.uploadURL + this.apiUrls.usuariosURL + '/uploadArchivo';
            const res = await this.connection.uploadFile(url, archivo, true);
            if(!res.error) {
                return { error: null, data: { url: res.url } };
            }
            else throw new Error();
        } catch (error) {
            return this.connection.obtenerMensajeError(error.status, 'Ha ocurrido un error al cargar el archivo.');
        }
    }

    async obtenerServicios(params: string = null) {
        try {
            var url = this.apiUrls.baseURL + this.apiUrls.serviciosURL + '/search';
            if(params) url += '?' + params;
            var json = await this.connection.getRequest(url);

            var registros = [];
            for (let element of json.records) {
                registros.push(this.jsonConverters.servicioDeJSON(element));
            }
            return { error: null, data: { registros: registros } };
        } catch (error) {
            return this.connection.obtenerMensajeError(error.status, 'Ha ocurrido un error al obtener las líneas.');
        }
    }
}